<template lang="pug">
v-select(
	v-bind="inputProps"
	:model-value="inputValue"
	@update:model-value="inputUpdate"
	:items="timeOptions"

)
	//menu-props="auto"
	template(v-slot:prepend-inner)
		v-icon(icon="mdi-clock-time-eight-outline" color="accent")
</template>
	
<script setup>
import { computed, ref } from 'vue';

const timeOptions = ref([]);

timeOptions.value = (() => {
	const options = [];
	for (let hour = 0; hour < 24; hour++) {
		options.push(String(hour).padStart(2, '0')+':00');
		//options.push(String(hour).padStart(2, '0')+':30');
	}
	return options;
})();

const props = defineProps(['modelValue', 'inputProps']);
const emit = defineEmits(['update:modelValue']);

const inputValue = computed(() => {
	if(!props.modelValue) return '';
	if(typeof(props.modelValue.toLocaleTimeString) != 'function') return;
	return props.modelValue.toLocaleTimeString(undefined, {minute: '2-digit', hour: '2-digit', hour12: false});
});

function inputUpdate(timeText){
	if(!timeText) return;
	const parts = timeText.split(':').map(Number).filter(p => !isNaN(p));
	if(!parts || parts.length != 2) return;
	if(parts[0] < 0 || parts[0] > 24) return;
	if(parts[1] < 0 || parts[1] > 59) return;
	const newDate = new Date(props.modelValue);
	
	newDate.setMinutes(parts[1]);
	newDate.setHours(parts[0]);

	// TODO: show a message when is invalid?
	if(isNaN(newDate)) return;
	emit('update:modelValue', newDate);
}

</script>